import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface AuthState {
  username: string | null;
  accessToken: string | null;
  refreshToken: string | null;
  setTokens: (a: string, r: string, username?: string) => void;
  clear: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      username: null,
      accessToken: null,
      refreshToken: null,
      setTokens: (a, r, username) => set((s) => ({ accessToken: a, refreshToken: r, username: username ?? s.username })),
      clear: () => set({ accessToken: null, refreshToken: null, username: null }),
    }),
    { name: 'heroage.auth' },
  ),
);
